import React from "react";
import OrdersList from "./OrdersList";
import { StyledBody } from "./styled";

function OrdersPage({ setLoginLoader }) {
  return (
    <StyledBody>
      <OrdersList setLoginLoader={setLoginLoader} />
    </StyledBody>
  );
}

export default OrdersPage;
